// Gesto de recolher/devolver a conversa do Espelho (Rafa, 30/08).
//
// Com a conversa aberta o avatar fica atrás e não havia como voltar a ele
// sem sair da tela. O gesto: PUXAR A THREAD PARA BAIXO revela o
// avatar/energia (como recolher uma folha); puxar para cima na tela do
// avatar devolve a conversa. Reversível e sem brigar com o scroll: o
// gesto de revelar só ARMA quando a thread já está no TOPO — no meio da
// conversa o dedo continua sendo scroll normal.
//
// PURO e exportado (o idioma de computeKeyboardOffsets/mirrorStreamGate):
// a decisão inteira mora aqui, o MirrorChat só faz o fio dos eventos de
// toque — e o teste bate direto na decisão com sequências reais de
// touchstart/move, sem simular DOM.

/** Distância de arrasto que confirma o gesto. 70px: acima do ruído de um
 *  toque impreciso (~10-20px) e bem abaixo de "arrastar até o meio da
 *  tela" — o gesto tem que ser mais leve que abrir o histórico. */
export const PULL_GESTURE_PX = 70;

/** Rastreador do gesto de REVELAR (puxar a thread para baixo).
 *  null = desarmado (o toque começou com a thread fora do topo, ou já
 *  disparou). */
export type PullTracker = { startY: number } | null;

/** touchstart na thread: arma SÓ com a thread no topo (scrollTop ≤ 0).
 *  Fora do topo o toque pertence ao scroll — o gesto nem observa. */
export function beginPull(threadScrollTop: number, touchY: number): PullTracker {
  return threadScrollTop <= 0 ? { startY: touchY } : null;
}

/** touchmove na thread. Desarma se a thread saiu do topo no meio do
 *  arrasto (o dedo virou scroll — iOS pode rolar mesmo partindo do topo,
 *  no overscroll reverso); revela quando o arrasto para BAIXO passa do
 *  limiar. `reveal: true` vem com o tracker já desarmado — dispara UMA vez. */
export function trackPull(
  tracker: PullTracker,
  threadScrollTop: number,
  touchY: number,
): { tracker: PullTracker; reveal: boolean } {
  if (tracker === null) return { tracker: null, reveal: false };
  if (threadScrollTop > 0) return { tracker: null, reveal: false };
  if (touchY - tracker.startY >= PULL_GESTURE_PX) {
    return { tracker: null, reveal: true };
  }
  return { tracker, reveal: false };
}

/** Rastreador do gesto de DEVOLVER (puxar para cima na tela do avatar).
 *  O chamador só arma quando há conversa recolhida para devolver
 *  (mensagens existem, conversa fechada, sem histórico/live). */
export function beginRestore(touchY: number): { startY: number } {
  return { startY: touchY };
}

/** touchmove no palco: devolve a conversa quando o arrasto para CIMA
 *  passa do limiar. Arrasto para baixo nunca devolve. */
export function trackRestore(
  tracker: { startY: number } | null,
  touchY: number,
): boolean {
  return tracker !== null && tracker.startY - touchY >= PULL_GESTURE_PX;
}
